import type { DisciplineWithSubdisciplines } from "@lib/types/conference-statistics";

interface DropdownData {
    [key: string]: DisciplineWithSubdisciplines[];
}

const DEFAULT_SUBDISCIPLINE_PLACEHOLDER = "Research Area";

export function initConferenceDropdowns(): void {
    const dropdownsData = document.getElementById("dropdowns-json");
    if (!dropdownsData) {
        return;
    }

    const data: DropdownData = JSON.parse(dropdownsData.textContent || "{}");

    initDisciplineSelects(data);
    initConferenceForms();
}

function initDisciplineSelects(data: DropdownData): void {
    document.querySelectorAll<HTMLSelectElement>("[data-discipline-select]").forEach((select) => {
        const targetId = select.dataset.subdisciplineSelect;
        const dataKey = select.dataset.key;

        if (!targetId || !dataKey) {
            return;
        }

        const subdisciplineSelect = document.getElementById(targetId) as HTMLSelectElement;
        if (!subdisciplineSelect) {
            return;
        }

        select.addEventListener("change", () => {
            const selectedSlug = select.value;
            const disciplines = data[dataKey] || [];
            const discipline = disciplines.find(d => d.slug === selectedSlug);

            subdisciplineSelect.innerHTML = `<option disabled selected>${DEFAULT_SUBDISCIPLINE_PLACEHOLDER}</option>`;

            if (discipline?.subdisciplines && discipline.subdisciplines.length > 0) {
                subdisciplineSelect.disabled = false;
                subdisciplineSelect.parentElement?.classList.remove("disabled");

                discipline.subdisciplines.forEach((sub) => {
                    const option = document.createElement("option");
                    option.value = sub.slug;
                    option.textContent = sub.name;
                    subdisciplineSelect.appendChild(option);
                });
            } else {
                subdisciplineSelect.disabled = true;
                subdisciplineSelect.parentElement?.classList.add("disabled");
            }
        });
    });
}

function initConferenceForms(): void {
    document.querySelectorAll<HTMLFormElement>("[data-conference-form]").forEach((form) => {
        form.addEventListener("submit", (e) => {
            e.preventDefault();

            const formData = new FormData(form);
            const discipline = formData.get("discipline") as string;
            const subdiscipline = formData.get("subdiscipline") as string;
            const formType = form.dataset.conferenceForm;

            if (!discipline) {
                return;
            }

            let url = "";
            if (formType === "upcoming") {
                url = `/upcoming-conferences/${discipline}`;
            } else if (formType === "best") {
                url = `/conference-rankings/${discipline}`;
            }

            if (subdiscipline && subdiscipline !== DEFAULT_SUBDISCIPLINE_PLACEHOLDER) {
                url += `/${subdiscipline}`;
            }

            window.location.href = url;
        });
    });
}
